<template>
	<select @change='change' :id="id" v-model="selected" class='form-control my-control' :class='field_class' data-num='f_12' data-table='1'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const REGION = 'region_list.php'
	const HEADER = 'get_header.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'region',
		data: function () { 
			return {
				selected: '0',
				options: [],
				id: `${this.type}_region`,
			}
		},
		props: {
			type: '',
			reg_id: false,
			field_class: ''
		},
		methods: {
			change: function () {
				EventBus.$emit(`${this.type}_region`, this.selected)
			}
		},
		watch: {
			reg_id (id) {
				if (typeof id !== 'undefined') {
					fetch(DB + REGION, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.options = [{id: '0', name: ''}, ...data]; 
							this.selected = id ? id : '0'
							EventBus.$emit('init_region_correct', this.selected)
						}
						else {
							this.options = []
						}
					})
					.catch(err => console.log(err))
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// region.vue?b34a5a10